function Logo(props) {
    return (
        <img className={'img-fluid'} style={{maxWidth:100}} src={`/images/logo.png`} alt={'logo'}/>
    );
}

export default Logo;
